import { useState } from "react";
import { useDispatch } from "react-redux";
import { store } from 'Store';
import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { setGlobalErrorStatus, setGlobalWarningStatus } from 'Components/StatusHandling'
import { ERROR_MESSAGES, WARNING_MESSAGES } from "Utils/constants";
import { ICONS } from "Utils/icons";
import { TableIconTextButton } from "Components/Button";
import { Download } from "@mui/icons-material";

const AltProdBatchCompleted = ({ isPSOPPCAdmin, isVendorLevel3 }) => {
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const dispatch = useDispatch();

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  const completedAltProdBatchHeader = "Processed Production Data Submissions";
  const completedAltProdBatchSearchFieldText = "Search by ID";

  const [completedAltProdBatchSortColumn, setCompletedAltProdBatchSortColumn] = useState({
    sortField: "submitDate",
    sortDirection: "desc"
  });

  // Flag: trigger api to reload data
  const [reloadCompletedAltProdBatch, setReloadCompletedAltProdBatch] = useState(false);
  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    }
  );

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      //console.log("printout rowName", rowName);
      return {
        id: rowName.id,
        pseId: rowName.pseBatchId,
        tabKey: "completed"
      };
    }

    /** PSO ID column will be displayed when PSOPPC Admin or Vendor Level 3 */
    if (isPSOPPCAdmin || isVendorLevel3) {
      listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }));
    }

    listColumns.push(Datatable_Column({ name: "Alt Batch ID", columnName: "id", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: "", pathname: "/eventDataSubmission/altBatchDetail", text: null, state: nameState }, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "CF Version", columnName: "timePrdCD", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "No Of Files", columnName: "numOfFiles", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Alt Batch Status", columnName: "batchStatusDesc", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "pseBatchId", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Batch Status", columnName: "pseBatchStatusDesc", selectedRows: selectedList, sortable: true, sortFieldNum: 5, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Submission Date", columnName: "submitDate", selectedRows: selectedList, sortable: true, sortFieldNum: 6, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));
    //listColumns.push(Datatable_Column({ name: "Report", columnName: "viewReport", selectedRows: selectedList, sortable: false, sortFieldNum: 7, isButton: true, buttonData: { action: handleFileDownload, text: "Download", icon: ICONS.download }, sortingInfo: sortingInfo, title: 'Download Report to View' }));

    listColumns.push({
      id: "viewReport",
      name:
        <div className="datatable-col-name">
          Report
        </div>,
      selector: row => {
        // 2025/07/10 New Update: show alternate detail report all the time
        if (row.batchStatusId === 8 || row.batchStatusId === 9) {
          return (
            <div className="non-link-table-cell-data is-button is-break-all">
              <TableIconTextButton onClick={() => handleFileDownload(row)} className="table-action" variant="table"
                title={"Download Report to View"} icon={ICONS.download}
                content={"Download"}
              >
              </TableIconTextButton>
            </div>
          )
        }
        /** show pse batch detail report if alt batch is accepted and pse batch is (accepted or rejected)
        if (row.batchStatusId === 8 && row.pseBatchStatusID === 4) {
          return (
            <div className="non-link-table-cell-data is-button is-break-all">
              <TableIconTextButton onClick={() => handleFileDownload(row)} className="table-action" variant="table"
                title={"Download Report to View"} icon={ICONS.download}
                content={"Download"}
              >
              </TableIconTextButton>
            </div>
          )
        }*/
        // else display nothing
        return (
          <></>
        )
      },
      sortable: true,
      sortField: 1,
      sortColumnName: 'name',
    });

    return listColumns;
  }

  // handle view report download
  const handleFileDownload = async (row) => {
    let res = null;
    // 2025/07/10 New Update: show alternate detail report all the time
    if (row.batchStatusId === 8 || row.batchStatusId === 9) {
      res = await submitAltDownload(row.id);
    }
    /**
    if (row.batchStatusId === 9) {
      // show alternate detail report if alt batch is rejected
      res = await submitAltDownload(row.id);
    }

    if (row.batchStatusId === 8 && row.pseBatchStatusID === 4) {
      // show pse batch detail report if alt batch is accepted and pse batch is (accepted or rejected)
      res = await submitDownload(row.pseBatchId);
    }*/

    if (res) {
      // get filename from the res content-disposition
      const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');

      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    }
  }

  // api to download view report
  const submitAltDownload = async (altBatchId) => {
    const call = {
      batchId: altBatchId,
      isTestSubmission: "N"
    }

    const url = '/api/report/altBatchDetail';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch(async (error) => {
      //console.log("error handleFileDownload()", error);
      let parsedData = null;
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          parsedData = JSON.parse(text);
        } catch (_) {}
      }
      const payload = { err: error, data: parsedData ?? error.response };
      payload.data?.status === 413 ?
        setGlobalWarningStatus({
          dispatch,
          popupData: {
            visible: true,
            title: WARNING_MESSAGES.WARNING.title,
            msg: getPopupWarningMessage(payload?.data?.globalErrorMessageList?.[0] ?? WARNING_MESSAGES.WARNING.message),
            showContactHelp: false
          },
          redirect: { redirect: false, redirectFirst: false, path: "", data: {} },
          error
        }) :
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        }
      );
    });
  }

  const submitDownload = async (batchId) => {
    const call = {
      batchId: batchId,
      isTestSubmission: "Y"
    }

    const url = '/api/report/batchDetail';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "N"
    }
    var url = '/api/alt/completedBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }
  
  const getPopupWarningMessage = (payload) => {
    return (
      <>
        <p>{payload} Please contact PSOPPC help desk at <a className={"supportEmail"} href={'mailto:support@psoppc.org'}>support@psoppc.org</a> to generate this report.</p>
      </>
    );
  }

  return (
    <>
      <DatatableBase
        tableClassName="altProdCompletedTable"
        reload={reloadCompletedAltProdBatch}
        setReload={setReloadCompletedAltProdBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        searchFieldText={completedAltProdBatchSearchFieldText}
        datatableHeader={completedAltProdBatchHeader}
        datatableDescription={null}
        sortingColumn={completedAltProdBatchSortColumn.sortField}
        sortingOrder={completedAltProdBatchSortColumn.sortDirection}
      >
      </DatatableBase>
    </>
  )
}

export default AltProdBatchCompleted;